export const toc = () => {
    const articleContent = document.querySelector(".article-text-with-toc");

    // On page TOC
    if (articleContent) {
        const articleTocWrapper = document.querySelector(".article-toc-links");
        const articleToc = document.querySelector(".article-toc-links ol");

        const articleHeadings = articleContent.querySelectorAll(".article-text-with-toc .section h2");

        if (articleHeadings.length) {
            articleTocWrapper.classList.remove("hide");

            for (const articleHeading of articleHeadings) {
                if (articleHeading.parentNode.id) {
                    var articleTocElement = document.createElement("li");
                    var articleTocElementLink = document.createElement("a");

                    articleTocElementLink.href = "#" + articleHeading.parentNode.id;
                    articleTocElement.appendChild(articleTocElementLink);

                    articleTocElementLink.innerText = articleHeading.innerText;
                    articleToc.appendChild(articleTocElement);
                }
            }

            const articleTocLinks = document.querySelectorAll(".article-toc-links ol a");

            // Attach click events
            if (articleTocLinks) {
                for (const articleTocLink of articleTocLinks) {
                    articleTocLink.addEventListener("click", event => {
                        event.preventDefault();
                        removeTocActiveClasses();
                        event.currentTarget.classList.add("active");

                        const articleTocLinkHash = event.currentTarget.hash.substr(1);

                        window.scrollTo({
                            top: document.getElementById(articleTocLinkHash).offsetTop - 80
                        });

                        updateHash(articleTocLinkHash);
                    });
                }
            }
        }

        // Remove active classes
        function removeTocActiveClasses() {
            const sidebarTocLinks = document.querySelectorAll(".article-toc a");
            for (const sidebarTocLink of sidebarTocLinks) {
                sidebarTocLink.classList.remove("active");
            }
        }

        // Update browser hash
        function updateHash(hash) {
            if (history.pushState) {
                history.pushState(null, null, "#" + hash);
            } else {
                location.hash = "#" + hash;
            }
        }
    }
};
